
/**
 * 统一的 API 请求工具
 * 自动处理 JWT token 和 401 错误
 */

export const apiRequest = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  // 默认配置
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // 如果有 token,添加到请求头
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  // 合并配置
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);

    // 检查 401 错误 (Token 过期)
    if (response.status === 401) {
      console.log('Token expired or invalid, redirecting to login...');
      localStorage.clear();
      window.location.href = '/';
      throw new Error('Session expired');
    }

    return response;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

/**
 * GET 请求
 */
export const apiGet = async (url) => {
  return apiRequest(url, { method: 'GET' });
};

/**
 * POST 请求
 */
export const apiPost = async (url, data) => {
  return apiRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * PUT 请求
 */
export const apiPut = async (url, data) => {
  return apiRequest(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

/**
 * DELETE 请求
 */
export const apiDelete = async (url) => {
  return apiRequest(url, { method: 'DELETE' });
};

/**
 * 上传文件
 */
export const apiUpload = async (url, formData) => {
  const token = localStorage.getItem('token');
  
  const config = {
    method: 'POST',
    body: formData,
    headers: {},
  };

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, config);

    if (response.status === 401) {
      console.log('Token expired or invalid, redirecting to login...');
      localStorage.clear();
      window.location.href = '/';
      throw new Error('Session expired');
    }

    return response;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};
